"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("reactstrap/lib/Button"));

var _Spinner = _interopRequireDefault(require("reactstrap/lib/Spinner"));

var _utils = require("../lib/utils");

var _bouncer = _interopRequireDefault(require("../bouncer/bouncer"));

var _icon = _interopRequireDefault(require("../icon/icon"));

require("./button.css");

var renderBouncer = function renderBouncer(_ref) {
  var isLoading = _ref.isLoading;
  return isLoading ? /*#__PURE__*/_react["default"].createElement(_bouncer["default"], {
    size: "md",
    className: "oui-btn-loading-bouncer"
  }) : null;
};

var renderButtonContent = function renderButtonContent(_ref2) {
  var type = _ref2.type,
      icon = _ref2.icon,
      label = _ref2.label,
      isSubmitting = _ref2.isSubmitting;
  var iconComp = icon ? /*#__PURE__*/_react["default"].isValidElement(icon) ? /*#__PURE__*/_react["default"].cloneElement(icon, {
    key: "button-icon",
    className: label ? (0, _utils.gatherClasses)(null, "oui-mr-2", icon.props.className) : icon.props.className
  }) : /*#__PURE__*/_react["default"].createElement(_icon["default"], (0, _extends2["default"])({
    muted: false
  }, icon, {
    key: "button-icon"
  })) : null;
  var labelComp = label ? /*#__PURE__*/_react["default"].createElement("span", {
    className: "oui-btn-label",
    key: "button-label"
  }, label) : null;
  var spinnerComp = type === "primary" && isSubmitting ? /*#__PURE__*/_react["default"].createElement(_Spinner["default"], {
    className: "submit-spinner",
    color: "light",
    size: "sm",
    key: "button-spinner"
  }) : null;
  return [iconComp, labelComp, spinnerComp];
};
/**
 * Button is the most common component of any UI
 * It is used to trigger some action like submit or reset etc
 * It has couple of states like active, disabled
 * and types like primary, secondary and link button
 */


var Button = function Button(props) {
  /**
   * If button type is link then only honour given href
   * so that the button is created using <a>
   */
  var type = props.type,
      propHref = props.href,
      dataTestId = props.dataTestId,
      active = props.active,
      block = props.block,
      disabled = props.disabled,
      isSubmitting = props.isSubmitting,
      label = props.label,
      ariaLabel = props.ariaLabel,
      isLoading = props.isLoading,
      isSuccess = props.isSuccess,
      target = props.target;
  var href = type !== "link" ? null : propHref;
  var btnType = type === "link" ? "link" : type === "danger" ? "danger" : "primary";

  if (isSuccess) {
    btnType = "success";
  }

  return /*#__PURE__*/_react["default"].createElement(_Button["default"], (0, _extends2["default"])({
    "data-testid": dataTestId,
    active: active,
    block: block,
    className: (0, _utils.gatherClasses)(props, isLoading && "oui-btn-loading"),
    color: btnType,
    disabled: disabled || isSubmitting,
    href: href,
    target: href !== null ? target : undefined,
    outline: type === "secondary"
  }, (0, _utils.gatherConditionalProps)(props, "size", "onClick", "onMouseUp", "onMouseDown"), {
    "aria-label": label ? "" : ariaLabel
  }), isLoading && renderBouncer(props), renderButtonContent(props));
};

Button.defaultProps = {
  type: "secondary",
  href: null,
  size: "md",
  disabled: false,
  block: false,
  dataTestId: "orion-button"
};
Button.displayName = "OrionButton";
Button.propTypes = {
  /**
   * label: the label of the button
   */
  label: _propTypes["default"].string,

  /**
   * type: type of the button. Any one from the given list
   * Default is secondary
   */
  type: _propTypes["default"].oneOf(["primary", "secondary", "link", "danger", "success"]),

  /**
   * href: href is required for link button
   * If href is provided then the button is created using <a> else using <button>
   */
  href: _propTypes["default"].string,

  /**
   * size: button size.
   * Default is md
   */
  size: _propTypes["default"].oneOf(["lg", "md", "sm"]),

  /**
   * disabled: button in the disabled state.
   */
  disabled: _propTypes["default"].bool,

  /**
   * onClick: button click handler function
   */
  onClick: _propTypes["default"].func,

  /**
   * block: full width button
   */
  target: _propTypes["default"].oneOf(["_blank", "_self", "_parent", "_top"]),
  block: _propTypes["default"].bool,
  isSuccess: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  active: _propTypes["default"].bool,
  icon: _propTypes["default"].oneOfType([_propTypes["default"].shape({
    src: _propTypes["default"].string,
    size: _propTypes["default"].oneOf(["xs", "sm", "md", "lg"]),
    width: _propTypes["default"].string,
    height: _propTypes["default"].string,
    classes: _propTypes["default"].string,
    onClick: _propTypes["default"].func
  }), _propTypes["default"].node]),
  dataTestId: _propTypes["default"].string,
  isSubmitting: _propTypes["default"].bool,
  ariaLabel: _propTypes["default"].string,
  isLoading: _propTypes["default"].bool
};
var _default = Button;
exports["default"] = _default;